import { Component, OnInit, NgZone, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { GroupService } from "../../../service/group.service";
import { Observable, Subscription, timer } from "rxjs";
import { Store } from '@ngrx/store';
import { AppState } from "../../../models/app.state";
import { eventEmitterService } from '../../../service/eventEmitter.service';
import { FeedService } from '../../../service/feed.service';
declare var $: any;
@Component({
  selector: 'app-creategroup',
  templateUrl: './creategroup.component.html',
  styleUrls: ['./creategroup.component.css']
})
export class CreategroupComponent implements OnInit {
  @ViewChild('createGroupModal', { static: false })
  isImage = false;
  socketId;
  group: FormGroup;
  src;
  imageCoords;
  error;
  groupInfo;
  successMsg;
  disabled = false;
  errorMsg;
  resetVal;
  buildings = [];
  clickedBuildings = [];
  private timer;
  private sub: Subscription;
  image_src;
  buildingArray =[];
  buildingNames=[];
  names='';
  groupImageTemp;  
  isToShow = false;
  constructor(private fb: FormBuilder,
  private groupService : GroupService,
  private store: Store<AppState>,
  private eventService : eventEmitterService,
  private _feed: FeedService,

  ) { }

  ngOnInit() {
    var that = this;
    $(window).ready(function(){
      $('#img_upload_modal .modal-footer button.close').click(function(){
        var imgSrcFileObj = $('#add_group_modal').find('#img_upload_modal img-cropper input[type=file]')[0]
        if (imgSrcFileObj.files.length > 0){
          var fileInfo = imgSrcFileObj.files[0];
          var fileName = !!fileInfo ? fileInfo.name : null;
          var groupImage = $('span[data-target="#img_upload_modal"] img').attr('src');
          that.groupImageTemp = dataURLtoFile(groupImage, fileName);
        }
        else{
          that.groupImageTemp = null;
        }
      })
      $('#add_group_modal').on('hidden.bs.modal', function () {
        that.groupImageTemp = null;
      })

      function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
      }

    });
    
    this.eventService.eventEmit$
    .subscribe(popup => {
        //If user click New Message button from Message header component, 
        //Here listening that evet to show new message user search section
        if(popup.openGroupPopup){
          this.isToShow = true;
          this.buildingArray = [];
          this.buildingNames = [];
          this.names = '';
          this.src = null;
          this.group.reset();
          $('#img_upload_modal').modal('hide');
          $('div.checkbox_inputs').find('input[type="checkbox"]').each(function (index, ele) {
            $(this).prop('checked', false);
          });
        }
      if (popup.modalClose) {
        this.isToShow = false;
      }
      });

      //Get socket information
      self["io"].socket.on('connected', (connected) => {
         this.socketId = connected['session'].socketId;
      });

    this.timer = timer(100, 200);
    this.sub = this.timer.subscribe(t => this.checkPopupWindow());


    //Get user building information to display building on create a group modal window
    this.groupService.getUserBuildingsInfo().subscribe((res)=>{
      if(res){
        if(res.buildingsInfo){
            this.buildings = res.buildingsInfo;
        }
      }
    });

    //Build reactive form object
    this.group = this.fb.group({
      groupName: ['', Validators.compose([Validators.required])],
      buildingSelect: [''],
      description: ['', Validators.compose([Validators.required])],
      shareToFeed : ['']
    });

    //this._feed.getAllFeeds();
  }

  /*
   * This function is used for detect the image source after upload a group image
   * it will execute every 2 milli seconds until the image src found.
   * If image source found , the timer subscription value will be unsubscribed.
   */
  checkPopupWindow(){

      //this.image_src = $('#add_group_modal').find('#edit-profile img#image').attr('src');
      if(this.image_src){

        $('#add_group_modal').show();
        if($('#add_group_modal').is('visible')){
            this.sub.unsubscribe();
        }
      }
  }

  isImageUpdate(e){
    //console.log(e);
    if (e) this.isImage = true;
  }

  /*
   * Make a buildingId array based on dropdown buildings selected values  
   */ 
  clickedItem(buildingId, $event){

    if(this.clickedBuildings.indexOf(buildingId) > -1){
        this.clickedBuildings = this.clickedBuildings.filter(value => value !== buildingId);
    }else{
       this.clickedBuildings.push(buildingId);
    }
  }

  buildingSelect(){
     $('#allBuildingLists').toggle();
  }

  /*
   * Create a Group with all fields validations  
   */ 
  createGroup(value, valid, createGroupForm){
    var groupName = $.trim($(createGroupForm).find("#groupName").val());
    var groupDesc = $.trim($(createGroupForm).find("#groupDesc").val());
    this.image_src = (sessionStorage.getItem('groupImage')) ? sessionStorage.getItem('groupImage') : null;

    this.resetVal = false;

    if(groupDesc == ''){
      valid = false;
      value.description = '';
      $(createGroupForm).find("#groupDesc").val('').focus();
      $(createGroupForm).find("#desc-error").show();
    }

    if(groupName == ''){
      valid = false;
      value.groupName = '';
      $(createGroupForm).find("#groupName").val('').focus();
      $(createGroupForm).find("#title-error").show();
    }

    if(valid){

      this.disabled = true;

      $(createGroupForm).find("#title-error").hide();
      $(createGroupForm).find("#desc-error").hide();

      value.buildingSelect = this.clickedBuildings;
     // value.imageSrc = this.image_src;

      //Build form object for construct form fields values to pass via service
      var groupImage = this.groupImageTemp;
      let formData = new FormData();
      value.socketId = this.socketId;
      value.file = false;        
      groupImage = (groupImage !== undefined && groupImage != '') ? groupImage : null;
      if(groupImage){
         value.file = true;
      }
      let data = JSON.stringify(value);
      formData.append('formValue', data);
      if(groupImage){
         formData.append('groupImage', groupImage);
      }
      //Call a service function with all form fields value
      this.groupService.createGroup(formData).subscribe((res)=>{
           if(res){
              if(res.success==true){

                this.eventService.eventEmit$.next({groupReset : true})

                //After group create , set success message, and reset form values
                this.image_src = null;
                 $('#add_group_modal').find('#edit-profile img').attr('src','');
                 $('#add_group_modal').find('.profile-img-container .profile-img img#preview').attr('style','');
                 this.successMsg = res.message;
                 this.groupInfo = res.group;
                 this.reset(createGroupForm);
                 this.imageCoords = null;
                 //this.store.dispatch({ type: 'ADD_GROUP_IMAGE',payload: <any>{image : null}});
                  sessionStorage.removeItem('groupImage');
              }else{
                 this.errorMsg = res.message;
              }

            }
            this.disabled = false;
       });
    }

  }

  onChangeTitle(createGroupForm){
    $(createGroupForm).find("#title-error").hide();
  }

  onChangeDesc(createGroupForm){
    $(createGroupForm).find("#desc-error").hide();
  }
  /*
  * Modal window close button action
  */
  popupClose(pop) {
    this.eventService.eventEmit$.next({ modalClose: true });
    if ((window as any).$ && typeof (window as any).$('#add_group_modal').modal === 'function') {
      (window as any).$('#add_group_modal').modal('hide');
    }
  }

  /*
   * Reset form fields values
   * and hide modal window
   */
  reset(createGroupForm){
      this.resetVal = true;
      setTimeout(()=>{
         this.clickedBuildings = [];
         this.successMsg = false;
         (window as any).$('#add_group_modal').modal('hide');
      },1000);
      createGroupForm.reset();
      //window.location.reload();
      //this.router.navigate(['/groups?create=true']);
  }

  /*
   * Called ngOnDestroy() when a user change over to other page
   * All timer subscribtion are unsubscribed()
  */

  ngAfterViewInit(){
    //  var that = this     
    // $('#add_group_modal').on('show.bs.modal', function () {
    //     that.buildingArray = [];
    //     that.buildingNames = [];
    //     that.names = '';
    //     that.group.reset();
    //     $('div.checkbox_inputs').find('input[type="checkbox"]').each(function (index, ele) {
    //       console.log('is Checked valv', $(this).prop('checked'));
    //       $(this).prop('checked', false);
    //     });
    //   });
  }
 
  buildingCheckNames(event, building) {
    console.log('Method is being called')
    console.log(event);
    this.names = '';
    if (event == true) {
      this.buildingArray.push(building.id);
      this.buildingNames.push((building.buildingName) ? building.buildingName : building.formattedAddress.split(',')[0]);
    } else if (event == false) {
      const index = this.buildingArray.indexOf(building.id);
      if (index !== -1) {
        this.buildingArray.splice(index, 1);
        this.buildingNames.splice(index, 1)
      }
    }
    this.names = this.buildingNames.toString();
    console.log(this.names);
  }
}
